import { Box, Divider, Modal, Typography } from '@mui/material';
import React from 'react';

const ConfirmModal = ({ open, onClose, msg, btnCancel = 'No', BtnConfirm = 'Yes', handleCancel = () => { }, handleConfirm = () => { } }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        bgcolor: 'background.paper',
        boxShadow: 24,
    };
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{ ...style, display: 'flex', flexDirection: 'column', borderRadius: '8px', overflow: 'hidden' }}>
                <Box sx={{ padding: '12px 16px' }}>
                    <Typography sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "24px",
                        letterSpacing: "0.02em", // 2%
                        textAlign: "center",
                    }}>
                        {msg}
                    </Typography>
                </Box>


                {/* Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        height: '40px',
                        borderTop: "1px solid #FF6100",
                    }}
                >

                    <button
                        onClick={handleCancel}
                        style={{
                            width: "50%",
                            border: "none",
                            background: "transparent",
                            color: "#FF6100",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        {btnCancel}
                    </button>

                    <Divider orientation="vertical" flexItem />

                    <button
                        onClick={handleConfirm}
                        style={{
                            width: "50%",
                            border: "none",
                            background: "#FF6100",
                            color: "#FFFFFF",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        {BtnConfirm}
                    </button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ConfirmModal;
